import { CircularProgress } from "@mui/material";
import React from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { ASSETS } from "../../../../utils/config";
import { goToUrl } from "../../../../utils/helpers";
import TextView from "../../../TextView";
import { fileIcons } from "../../../../constants/documentIcon";

const Container = styled.div`
  padding: ${(props) => props.padding};
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const IconView = styled.div`
  width: 34px;
  height: 40px;
  display: flex;
  justify-content: flex-start;
`;

const Icon = styled.img`
  width: 34px;
  height: 40px;
  object-fit: fill;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
`;

const DocumentPreview = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
`;


const DocumentBlock = ({ doc, showThumbnail }) => {
  const location = useLocation();
  const isEditPage = location.pathname.includes("builder");
  if (doc.loading)
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <CircularProgress size={28} />
      </div>
    );
  else
    return (
      <DocumentPreview
        showThumbnail={showThumbnail}
        onClick={() => !isEditPage && goToUrl(doc.src)}
      >
        <Row>
          <IconView>
            <Icon src={fileIcons[doc.type]} />
          </IconView>
          <TextView variant="largeText">{doc.title}</TextView>
        </Row>
      </DocumentPreview>
    );
};
export default DocumentBlock;
